import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeighingAdminComponent } from './weighing-admin/weighing-admin.component';
import { AppPropertiesService, AppPropertyComponentsModule, CommonLayoutModule, CommonUIModule } from '@sdbn/common';



@NgModule({
  declarations: [
    WeighingAdminComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    AppPropertyComponentsModule,
    CommonUIModule
  ]
})
export class WeighingAdminModule {

  constructor(
    private appPropertiesService: AppPropertiesService
  ) {

    appPropertiesService.registerAppPropertiesAdminComponent('tmc-yard.weighing.ui.weighing-properties-admin.tab-title', WeighingAdminComponent);


  }
 }
